import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-pending',
  templateUrl: './payment-pending.component.html',
  styleUrls: ['./payment-pending.component.scss']
})
export class PaymentPendingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
